import { useHistory } from 'react-router-dom'

export const useNews = () => {
  const history = useHistory()

  const redirectToNew = (slug: string) => {
    if (process.env.REACT_APP_NOTICIAS_EXTERNAL === 'true') {
      ;(window as any).open(
        `${process.env.REACT_APP_NOTICIAS_EXTERNAL_URL}/pt/web/guest/-/${slug}`,
      )
    } else {
      history.push(`/noticias/${slug}`)
    }
  }

  return {
    history,
    redirectToNew,
  }
}
